<template>
<div class="chapter">
<div class="inner_page">
<div class="frontmatter" title="Slow Cooker Double Dinners for Two">
<div class="frontcover">
<img alt="cover image" src="images/cover.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?583b470e